const getProvinceObject = (states, territories, value) =>
  value ? states.find((s) => s.value === value) || territories.find((s) => s.value === value) : null;

export default getProvinceObject;
